<div class="ant-modal" #modalElement [ngClass]="config.nzClassName!" [ngStyle]="config.nzStyle!" [style.width]="config.nzWidth! | nzToCssUnit" role="document">
  <div class="ant-modal-content">
    <div class="header-wrapper" *ngIf="config.nzClosable || config.nzTitle">
      <button *ngIf="config.nzClosable" (click)="onCloseClick()" ui-modal-close></button>
      <div *ngIf="config.nzTitle" [uiTitle]="config.nzTitle" ui-modal-title></div>
    </div>
    <div class="ant-modal-body" [ngStyle]="config.nzBodyStyle!">
      <div class="body-wrapper" ui-scrollable-content>
        <ng-template cdkPortalOutlet></ng-template>
        <div *ngIf="isStringContent" [innerHTML]="config.nzContent"></div>
      </div>
    </div>
    <div *ngIf="config.nzFooter !== null" [modalRef]="modalRef" (cancelTriggered)="onCloseClick()" (okTriggered)="onOkClick()" ui-modal-footer></div>
  </div>
</div>
